import React from 'react';
import FormLabel from './FormLabel';

interface FamilyTabProps {
  formData: any;
  handleChange: (field: string, value: any) => void;
  errors?: Record<string, string>;
}

export default function FamilyTab({ formData, handleChange, errors = {} }: FamilyTabProps) {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold">Data Keluarga</h3>
        <p className="text-gray-500 text-sm">Informasi pasangan dan kontak darurat</p>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <FormLabel>Nama Pasangan</FormLabel>
          <input
            type="text"
            value={formData.spouse_name}
            onChange={e => handleChange('spouse_name', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
            placeholder="Nama suami/istri"
          />
        </div>

        <div>
          <FormLabel>No. Identitas Pasangan</FormLabel>
          <input
            type="text"
            value={formData.spouse_id_number}
            onChange={e => handleChange('spouse_id_number', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
            placeholder="No. KTP pasangan"
          />
        </div>

        <div>
          <FormLabel>Nama Kontak Darurat</FormLabel>
          <input
            type="text"
            value={formData.emergency_contact_name}
            onChange={e => handleChange('emergency_contact_name', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
            placeholder="Nama kontak darurat"
          />
        </div>

        <div>
          <FormLabel>No. Telepon Kontak Darurat</FormLabel>
          <input
            type="text"
            value={formData.emergency_contact_phone}
            onChange={e => handleChange('emergency_contact_phone', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
            placeholder="08xxxxxxxxxx"
          />
        </div>
      </div>
    </div>
  );
}
